import {
    Component,
    EventEmitter,
    OnInit,
    Output,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { InputComponent } from "@components/input/input.component";
import { RadiobuttonGroupComponent } from "@components/radiobuttongroup/radiobuttongroup.component";
import { BusyService } from "~app/common/components/busy/busy.service";
import { IRadiobuttonItem } from "~app/common/components/radiobuttongroup/radiobutton/IRadiobuttonItem";
import { IHandelssortimentSearchParamsModel, ISearchHandelssortimentModel } from "~app/features/forsaljning/handelssortiment/handelssortiment.models";
import { MinaHandelssortimentService } from "../../services/mina-handelssortiment.service";
import { MinaHandelssortimentTexts } from "../mina-handelssortiment.texts";

@Component({
    selector: "rask-mina-handelssortiment-search-panel",
    templateUrl: "./mina-handelssortiment-search-panel.component.html",
    styleUrls: ["./mina-handelssortiment-search-panel.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        InputComponent,
        RadiobuttonGroupComponent,
        ButtonComponent
    ]
})
export class MinaHandlessortimentSearchPanelComponent implements OnInit {
    activetypes = [
        { key: "true",
            value: "Ja" },
        { key: "false",
            value: "Nej" }
    ] as IRadiobuttonItem[];
    formFilterHandelssortiment: UntypedFormGroup;

    // eslint-disable-next-line @angular-eslint/no-output-rename
    @Output("handelssortimentListaUtsokta") handelssortimentListaUtsokta = new EventEmitter<ISearchHandelssortimentModel[]>();
    handelssortimentSearchParams: IHandelssortimentSearchParamsModel;
    texts = MinaHandelssortimentTexts.texts;

    private readonly busyService = inject(BusyService);
    private readonly formBuilder = inject(UntypedFormBuilder);
    private readonly handelssortimentService = inject(MinaHandelssortimentService);

    constructor() {
        this.formFilterHandelssortiment = new UntypedFormGroup({});
        this.handelssortimentSearchParams = {};
    }

    mapFromForm(): IHandelssortimentSearchParamsModel {
        if (!this.handelssortimentSearchParams) {
            return { aktiv: true,
                wildcardSearch: "" };
        }
        return {
            wildcardSearch: this.formFilterHandelssortiment.get("wildcardSearch").value,
            aktiv: this.formFilterHandelssortiment.get("aktiv").value
        };
    }

    searchForHandelssortiment = () => {
        this.handelssortimentSearchParams = this.mapFromForm();
        this.handelssortimentSearchParams.forProduktion = true;
        const query = this.handelssortimentService.searchForHandelssortiment(this.handelssortimentSearchParams);
        this.busyService.addWork(query).subscribe((result: ISearchHandelssortimentModel[]) => {
            this.handelssortimentListaUtsokta.emit(result);
        });
    };

    clearHandelssortimentSearchParams = () => {
        this.handelssortimentSearchParams = {
            ids: null,
            sortimentskod: "",
            beteckning: "",
            produktnamn: "",
            handelssortimentsgrupp: "",
            namn: "",
            aktiv: true,
            sort: "-UDate",
            wildcardSearch: ""
        };
        this.formFilterHandelssortiment = this.formBuilder.group(this.handelssortimentSearchParams);
        this.formFilterHandelssortiment.get("aktiv").setValue(this.handelssortimentSearchParams.aktiv ? "true" : "false");
        this.searchForHandelssortiment();
    };

    ngOnInit(): void {
        this.clearHandelssortimentSearchParams();
    }
}
